/**
 * Normaliza o nome de um evento para o formato snake_case que o Segment grava
 * no warehouse (e que as planilhas de de-para usam como chave):
 * "Opportunity Unlocked" -> "opportunity_unlocked".
 *
 * Fonte única: tanto o `filtro_hubspot` quanto a feature dos eventos de JusMatch
 * resolvem o nome por aqui, para que um mesmo evento caia na mesma chave.
 */
export function normalizeEventName(event: string): string {
  return event
    .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');
}
